import { getTicks, parseCssPixels, round, thinPoints } from "./utils.js";

export function renderProfile(profile, root, chartWrap, chart) {
  const height = parseCssPixels(root.dataset.height, 360);
  const margin = { top: 28, right: 26, bottom: 58, left: 58 };
  const containerWidth = Math.max(chartWrap.clientWidth || root.clientWidth || 320, 320);
  const width = containerWidth;
  const plotWidth = width - margin.left - margin.right;
  const plotHeight = height - margin.top - margin.bottom;
  const range = Math.max(profile.maxElevation - profile.minElevation, 20);
  const minY = profile.minElevation - range * 0.08;
  const maxY = profile.maxElevation + range * 0.12;
  const totalDistance = Math.max(profile.totalDistance, 0.001);
  const displayPoints = thinPoints(profile.points, 900);
  const gradientPrefix = root.id || "bhgpxe";
  const lineGradientId = `${gradientPrefix}-line-gradient`;
  const areaGradientId = `${gradientPrefix}-area-gradient`;

  const x = (distance) => margin.left + (distance / totalDistance) * plotWidth;
  const y = (elevation) => margin.top + ((maxY - elevation) / (maxY - minY)) * plotHeight;
  const linePath = displayPoints.map((point, index) => `${index === 0 ? "M" : "L"}${round(x(point.distance))} ${round(y(point.elevation))}`).join(" ");
  const areaPath = `${linePath} L ${round(x(profile.totalDistance))} ${height - margin.bottom} L ${margin.left} ${height - margin.bottom} Z`;
  const yTicks = getTicks(minY, maxY, 5);

  chart.innerHTML = `
    <svg class="bhgpxe__svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id="${lineGradientId}" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stop-color="#14b8a6" />
          <stop offset="52%" stop-color="#22c55e" />
          <stop offset="100%" stop-color="#0ea5e9" />
        </linearGradient>
        <linearGradient id="${areaGradientId}" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="#22c55e" stop-opacity="0.34" />
          <stop offset="62%" stop-color="#5eead4" stop-opacity="0.12" />
          <stop offset="100%" stop-color="#ffffff" stop-opacity="0" />
        </linearGradient>
      </defs>
      ${yTicks.map((tick) => `
        <line class="bhgpxe__grid" x1="${margin.left}" x2="${width - margin.right}" y1="${round(y(tick))}" y2="${round(y(tick))}" />
        <text class="bhgpxe__axisLabel" x="${margin.left - 10}" y="${round(y(tick) + 4)}" text-anchor="end">${Math.round(tick)} m</text>
      `).join("")}
      ${profile.kmMarkers.map((marker) => `
        <line class="bhgpxe__km-line" x1="${round(x(marker.distance))}" x2="${round(x(marker.distance))}" y1="${margin.top}" y2="${height - margin.bottom}" />
      `).join("")}
      <path class="bhgpxe__area" d="${areaPath}" style="fill: url(#${areaGradientId});" />
      <path class="bhgpxe__line" d="${linePath}" style="stroke: url(#${lineGradientId});" />
      ${profile.kmMarkers.map((marker) => `
        <circle class="bhgpxe__km-dot" cx="${round(x(marker.distance))}" cy="${round(y(marker.elevation))}" r="4" />
        <text class="bhgpxe__elevation-label" x="${round(x(marker.distance))}" y="${round(y(marker.elevation) - 10)}" text-anchor="middle">${Math.round(marker.elevation)} m</text>
        <text class="bhgpxe__km-label" x="${round(x(marker.distance))}" y="${height - 24}" text-anchor="middle">${marker.km} km</text>
      `).join("")}
      <text class="bhgpxe__axisLabel" x="${width - margin.right}" y="${height - 8}" text-anchor="end">Distance</text>
    </svg>
  `;
  chartWrap.classList.add("has-chart");
}
